package com.nonopn.skywatcher.common.homepage

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.preview.HotPreviewApp
import com.nonopn.skywatcher.design.theme.AppColor
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.preview.PreviewDarkLightColumn
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Suppress("LongMethod", "UnusedPrivateMember", "MagicNumber")
@Composable
fun HomepageScreen(
    modifier: Modifier,
    defaultWidth: Dp = 0.dp,
    content: @Composable () -> Unit
) {
    val focusManager = LocalFocusManager.current
    val keyboardController = LocalSoftwareKeyboardController.current
    val scope = rememberCoroutineScope()
    val focusText = remember { mutableStateOf(false) }
    val focusRequester = remember { FocusRequester() }

    val release = {
        if (focusText.value) {
            focusText.value = false
            keyboardController?.hide()
            focusRequester.freeFocus()
            focusManager.clearFocus(true)
            scope.launch {
                delay(50)
                // scrollState.scrollTo(scrollState.maxValue)
            }
        }
    }

    // Get local density from composable
    val localDensity = LocalDensity.current

    // Create element height in pixel state
    var columnWidthPx by remember {
        mutableFloatStateOf(0f)
    }

    // Create element height in dp state
    var columnWidthDp by remember {
        mutableStateOf(defaultWidth)
    }

    Box(
        modifier = modifier.fillMaxSize()
            .onGloballyPositioned { coordinates ->
                columnWidthPx = coordinates.size.width.toFloat()
                columnWidthDp = with(localDensity) { coordinates.size.width.toDp() }
            }
            .background(AppColor.BackgroundBlue)
            .padding(16.dp)
    ) {
        if (focusText.value) {
            ClickableFull(release)
        }

        Row(
            modifier = Modifier
                .align(Alignment.Center)
                .clip(
                    RoundedCornerShape(
                        topStart = 10.dp,
                        topEnd = 10.dp,
                        bottomStart = 10.dp,
                        bottomEnd = 10.dp
                    )
                )
                .shadow(
                    elevation = 10.dp,
                    clip = true
                )
                .heightIn(0.dp, 400.dp) // mention max height here
                .widthIn(0.dp, 800.dp) // mention max width here
        ) {
            if (columnWidthDp >= 500.dp) {
                Column(
                    modifier = Modifier.weight(1f)
                        .fillMaxHeight()
                ) {
                    MainImage()
                }
            }

            Column(
                modifier = Modifier.weight(1f)
                    .fillMaxHeight()
            ) {
                content()
            }
        }
    }
}

@Composable
private fun ClickableFull(release: () -> Unit) {
    Box(
        modifier = Modifier.fillMaxSize()
            .clickable(onClick = release)
            .offset(x = 0.dp, y = 0.dp)
    )
}

@HotPreview(widthDp = 500, heightDp = 360, darkMode = true)
@HotPreview(widthDp = 500, heightDp = 360, darkMode = false)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = true)
@HotPreview(widthDp = 360, heightDp = 500, darkMode = false)
@Composable
private fun HomepageScreenPreview() {
    PreviewDarkLightColumn(submodifier = { Modifier.height(200.dp) }) { modifier, _ ->
        HotPreviewApp(isDarkTheme = isSystemInDarkTheme()) {
            HomepageScreen(
                modifier = modifier,
                defaultWidth = 500.dp
            ) {
                // nothing just yet
            }
        }
    }
}
